export default "__VITE_ASSET__DXnrSnNr__"